import { SettingsContainer } from './container';
import { UsersSectionContainer } from './sections/users/container';

export const SettingsRoute = SettingsContainer;
export const UsersSectionRoute = UsersSectionContainer;
